<template>
  <div class="text-center">
    <template v-if="loadingFinished">
      <template v-if="ccList.length">
        <div v-for="(cc, index) in ccList" :key="`credit-card-${index}`">
          <v-row no-gutters>
            <v-spacer />
            <v-col
              cols="10"
              sm="6"
              class="d-flex py-3 px-8 font-weight-bold"
              :class="{ 'grey--text': cc.isDefault !== 'Y' }"
            >
              <div class="text-left">
                {{ cc.issueBankName }}
              </div>
              <v-spacer />
              <div class="align-self-center">
                {{ cc.mchd }}
                <div class="mt-2">
                  <span class="text-small"
                    >{{ $t("creditcard_expiry_label")
                    }}{{ dateFormat(cc.expireYm, "MM/YY") }}</span
                  >
                  <span
                    :class="`expire-tag ${cc.expired ? 'expired' : 'active'}`"
                    >{{
                      cc.expired
                        ? $t("creditcard_expired_status")
                        : $t("creditcard_active_status")
                    }}</span
                  >
                </div>
              </div>
            </v-col>
            <v-spacer />
          </v-row>
          <v-row no-gutters>
            <v-spacer />
            <v-col cols="10" sm="6">
              <div class="red-dash-divider" />
            </v-col>
            <v-spacer />
          </v-row>
        </div>
        <v-row no-gutters align="center" justify="center" class="mt-5">
          <v-col cols="10" sm="6">
            <v-alert
              v-model="showInAppBrowserWarning"
              class="p-4 text-left red--text pink-1 body-2 font-weight-regular rounded-lg"
              prominent
              role="alert"
              type="alert"
            >
              <span v-html="$t('in_app_browser_warning')"></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-btn
          size="x-large"
          color="primary-1"
          class="font-weight-bold mt-10 nextBtn"
          depressed
          @click="updateCCInfo"
        >
          {{ $t("creditcard_management_cta") }}
        </v-btn>
        <div class="red--text mt-10">
          {{ $t("creditcard_add_new_card_tip") }}
        </div>
      </template>
      <template v-else>
        <v-img
          src="@/assets/image/images-add-creditcards@3x.png"
          :width="imageWidth"
          class="mx-auto mb-5"
        ></v-img>
        <v-btn
          outlined
          color="primary"
          depressed
          rounded
          @click="updateCCInfo"
          style="border: 2px solid"
          class="font-weight-bold"
          ><v-icon color="primary">mdi-plus</v-icon
          >{{ $t("creditcard_add_new_card") }}
        </v-btn>
        <div class="mt-8 font-weight-bold">
          <span class="red--text">{{ $t("creditcard_add_new_card_tip") }}</span>
          <br />
          <br />
          <span class="grey-darken-2--text">{{
            $t("creditcard_service_provider")
          }}</span>
        </div>
      </template>
    </template>
    <v-progress-circular
      v-else
      indeterminate
      color="primary-1"
      size="25"
      width="2"
      class="mx-auto"
    ></v-progress-circular>
  </div>
</template>

<script>
import OM from "@/api/order-management";
import { isIOSInAppBrowser } from "@/shared/webViewRedirect";

export default {
  data() {
    return {
      loadingFinished: false,
      ccList: [],
      winOpen: false,
      detectCloseInterval: null,
      showInAppBrowserWarning: false,
    };
  },
  computed: {
    imageWidth() {
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm)
        return "100";
      else return "120";
    },
  },
  mounted() {
    window.win = null;
    window.winUrl = null;
    this.showInAppBrowserWarning = isIOSInAppBrowser();
    this.getUserCCInfo();
  },
  methods: {
    dateFormat(date, format) {
      if (!date) return "";
      const year = date.substring(0, 4);
      const month = date.substring(4, 6);
      if (format === "MM/YY") {
        return `${month}/${year.substring(2, 4)}`;
      }
    },
    async getUserCCInfo() {
      this.loadingFinished = false;
      const { data: getCCresponse } = await OM.getUserCCInfo();
      if (getCCresponse.errCode == "00") {
        this.ccList = getCCresponse.ccList;
      }
      this.$store.dispatch("setOverlayLoading", false);
      this.loadingFinished = true;
    },
    async updateCCInfo() {
      if (!!window.win) window.open(window.winUrl, "credit-page");
      else {
        window.win = window.open("", "credit-page");
        const { data } = await OM.updateCCInfo();

        if (data.errCode == "00" && data.url) {
          // this.winOpen = true
          window.win.location = data.url;
          window.winUrl = data.url;
          this.detectCloseInterval = setInterval(() => {
            if (!window.win || window.win.closed) {
              this.$store.dispatch("setOverlayLoading", true);
              window.win = null;
              window.winUrl = null;
              // this.winOpen = false
              clearInterval(this.detectCloseInterval);
              setTimeout(() => {
                this.getUserCCInfo();
              }, 3000);
            }
          }, 500);
        }
      }
    },
    beforeDestroy() {
      clearInterval(this.detectCloseInterval);
    },
  },
};
</script>

<style lang="scss">
.grey-darken-2--text {
  color: $grey-darken-2;
}

.expire-tag {
  display: inline-flex;
  height: 22px;
  font-size: 12px;
  border-radius: 12px;
  padding: 0 8px;
  margin-left: 8px;
  justify-content: center;
  align-items: center;

  &.active {
    color: white;
    background-color: #28bd92;
  }

  &.expired {
    color: #e64343;
    border: 1px solid #e64343;
    background-color: #fff;
  }
}
</style>
